module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/_iter-step.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/_iter-step.js
// module chunks = 4